import { LinearProgress, linearProgressClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import useTheme from "../../components/useTheme/useTheme";

 
const BorderLinearProgress = styled(LinearProgress)(({ theme, themeState }) => ({

  height: 20,
  borderRadius: 15,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: themeState === "light" ? "#f2f2f2" : "#545554",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    height: 10,
    margin: "5px 0",
    backgroundColor: theme.palette.mode === "light" ? "#EF7B13" : "#EF7B13",
  },
}));

export default BorderLinearProgress;
